'use client'

export { SharedFonts } from '@landfolk/shared/ui/fonts/Fonts/Shared'
